var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "me-2",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 204",
    transform: "translate(-8010 17388)",
    style: {
      clipPath: "url(#z98hohvhua)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62103"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26184",
    d: "M203.736 262.759v-1.156a.608.608 0 1 1 1.21.009c.007.356.008.711.011 1.067 0 .009.011.018.035.053h7.28v-1.087c0-.442.247-.717.618-.709s.587.276.593.7c.005.345.006.689.01 1.033 0 .01.008.019.031.066.084.007.19.02.3.021.478 0 .956-.007 1.434 0a1.829 1.829 0 0 1 1.893 1.928v11.368a1.829 1.829 0 0 1-1.936 1.949h-13.2a1.828 1.828 0 0 1-1.935-1.949v-11.371a1.828 1.828 0 0 1 1.893-1.928c.569-.004 1.145.006 1.763.006zm-2.448 5.515v7.67c0 .66.193.852.858.852h12.932c.665 0 .855-.191.855-.854v-7.667zm3.661-4.274v.729c0 .795-.164 1.081-.615 1.076s-.6-.28-.6-1.059V264c-.668 0-1.3-.015-1.929.007a.566.566 0 0 0-.514.6c-.014.244 0 .489 0 .733v1.659H215.9a.449.449 0 0 0 .029-.091q0-.916.006-1.833c0-.992-.091-1.083-1.083-1.083h-1.364v1.123c0 .428-.232.688-.6.694s-.611-.26-.615-.708v-1.1z",
    transform: "translate(7810.389 -17648.473)",
    style: {
      fill: "#ff295c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26185",
    d: "m212.115 283.553 1.992-1.991c.8-.8 1.6-1.606 2.405-2.4a.61.61 0 1 1 .871.847Q215 282.4 212.6 284.79a.612.612 0 0 1-.964-.005q-1.173-1.16-2.334-2.333a.6.6 0 0 1-.052-.89.615.615 0 0 1 .916.032c.646.641 1.284 1.29 1.949 1.959z",
    transform: "translate(7805.66 -17657.923)",
    style: {
      fill: "#ff295c"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSvg);
export default __webpack_public_path__ + "static/media/calender-svg.0130d3d60233af640f8212604713f256.svg";
export { ForwardRef as ReactComponent };